/**
 * Tab navigation bar for the OAuth Settings page.
 */

import React from 'react';
import type { TabKey } from './types';

interface TabDefinition {
  key: TabKey;
  label: string;
}

const TABS: TabDefinition[] = [
  { key: 'profile', label: 'Profile' },
  { key: 'auth', label: 'Authentication' },
  { key: 'repository', label: 'Repository Access' },
  { key: 'api-tokens', label: 'API Tokens' },
];

interface TabNavProps {
  activeTab: TabKey;
  onTabChange: (tab: TabKey) => void;
}

export const TabNav: React.FC<TabNavProps> = ({ activeTab, onTabChange }) => {
  return (
    <div className="mb-4 border-b border-gray-200 dark:border-gray-700">
      <nav className="-mb-px flex space-x-6">
        {TABS.map(({ key, label }) => {
          const isActive = activeTab === key;
          const className = `py-3 px-1 border-b-2 font-medium text-sm transition-colors ${
            isActive
              ? 'border-blue-500 text-blue-600 dark:text-blue-400'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
          }`;
          return (
            <button key={key} onClick={() => onTabChange(key)} className={className}>
              {label}
            </button>
          );
        })}
      </nav>
    </div>
  );
};
